<template>
  <div></div>
</template>

<script>
import Tracking from "@/mixins/Tracking";

export default {
  name: 'tracking',
  components: {
  },
  mixins: [Tracking],
  data() {
    return {
      currentPage: '',
      event: 'Page View',
      productreference: '',
      productId: null,
      productType: null
    }
  },
  watch: {},
  created() {
    this.routeCheck();
  },
  mounted() {
  },
  methods: {
    routeCheck: function () {
      this.currentPage = this.$route.fullPath;
      let productreference = {
        'Web Page': this.currentPage
      };
      this.$store.dispatch('checkSession', {event: this.event, productreference: productreference, productid: this.productId, producttype: this.productType})

      this.$router.afterEach((to, from) => {
        this.productReference = JSON.stringify({
          'Web Page': to.fullPath
        });
        this.$store.dispatch('checkSession', {event: this.event, productreference: productreference, productid: this.productId, producttype: this.productType})
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/journey/Tracking.vue